import { Box } from "@chakra-ui/react";
import React from "react";

export const BadgeCount = (props) => {
  return (
    <Box
      display="inline-block"
      borderRadius="full"
      position="absolute"
      right="-0.2em"
      bottom="0em"
      color="black"
      border="1px solid"
      borderColor="black"
      bgColor="brand.primary"
      minWidth="1.5em"
      fontWeight={700}
      fontSize="0.7em"
      padding="0 0.2em"
    >
      {props.count}
    </Box>
  );
};
